export function getUserType(user) {
    if (!user.id) return "Unknown"
    return user.id.startsWith("auth0|") ? "Auth0" : "AD"
}
